import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";

export default function AddCertificate() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    student_name: "",
    college: "",
    dob: "",
    age: "",
    department: "",
    address: "",
    email: "",
    phone: "",
    internship_from: "",
    internship_to: "",
  });

  const [studentPhoto, setStudentPhoto] = useState(null);
  const [certPhoto, setCertPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!studentPhoto || !certPhoto) {
      setError("Please upload both images");
      return;
    }

    setLoading(true);
    setError("");

    const formData = new FormData();
    Object.entries(form).forEach(([k, v]) =>
      formData.append(k, v)
    );
    formData.append("student_photo", studentPhoto);
    formData.append("cert_photo", certPhoto);

    try {
      const res = await fetch(
        `${API_URL}/add`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await res.json();
      if (result.success) {
        alert(`Certificate added!\nCert ID: ${result.cert_id}`);
        navigate("/admin/dashboard");
      } else {
        setError("Failed to add certificate");
      }
    } catch {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-slate-800">
              Add Certificate
            </h1>
            <p className="text-sm text-slate-500">
              Create and issue a new internship certificate
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* LEFT */}
              <div className="md:col-span-2 space-y-6">
                {/* Student Info */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    name="student_name"
                    placeholder="Student Name"
                    value={form.student_name}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                  <input
                    name="college"
                    placeholder="College"
                    value={form.college}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <input
                    type="date"
                    name="dob"
                    value={form.dob}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                  <input
                    name="age"
                    placeholder="Age"
                    value={form.age}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                  <input
                    name="department"
                    placeholder="Department"
                    value={form.department}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                </div>

                <textarea
                  name="address"
                  placeholder="Address"
                  rows="3"
                  value={form.address}
                  onChange={handleChange}
                  className="input"
                  required
                />

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <input
                    name="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                  <input
                    name="phone"
                    placeholder="Phone"
                    value={form.phone}
                    onChange={handleChange}
                    className="input"
                    required
                  />
                </div>

                {/* Internship */}
                <div>
                  <p className="text-sm font-medium text-slate-600 mb-2">
                    Internship Duration
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <input
                      type="date"
                      name="internship_from"
                      value={form.internship_from}
                      onChange={handleChange}
                      className="input"
                      required
                    />
                    <input
                      type="date"
                      name="internship_to"
                      value={form.internship_to}
                      onChange={handleChange}
                      className="input"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="space-y-6">
                <p className="font-medium text-slate-700">
                  Uploads
                </p>

                <div className="space-y-2">
                  <label className="text-sm text-slate-500">
                    Student Photo
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setStudentPhoto(e.target.files[0])
                    }
                    className="w-full"
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm text-slate-500">
                    Certificate Image
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setCertPhoto(e.target.files[0])
                    }
                    className="w-full"
                    required
                  />
                </div>
              </div>
            </div>

            {error && (
              <p className="text-red-600 text-sm mt-4">
                {error}
              </p>
            )}

            {/* Actions */}
            <div className="flex justify-end gap-4 mt-8">
              <button
                type="button"
                onClick={() => navigate("/admin/dashboard")}
                className="px-6 py-2.5 border border-slate-300 rounded-xl hover:bg-slate-100 transition"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2.5 bg-indigo-600 text-white rounded-xl
                  hover:bg-indigo-700 transition disabled:opacity-50"
              >
                {loading ? "Adding..." : "Add Certificate"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
